export function selectEnabledFeatures(state) {
  return state?.loggedInEmployee?.data?.enabledFeatures ?? [];
}
